export default "__VITE_PUBLIC_ASSET__c28f36bf__"